import { Accordion, Stack } from "@mantine/core";
import type { ReactNode } from "react";

interface ChangeProcessAccordionItemProps {
  value: string;
  title: string;
  children: ReactNode;
  disabled?: boolean;
}

function ChangeProcessAccordionItem({
  value,
  title,
  children,
  disabled = false
}: ChangeProcessAccordionItemProps) {
  return (
    <Accordion.Item style={{ boxShadow: "none" }} value={value}>
      <Accordion.Control disabled={disabled}>{title}</Accordion.Control>
      <Accordion.Panel>
        <Stack gap="md">{children}</Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
}

export { ChangeProcessAccordionItem };
